import { createClient } from "@supabase/supabase-js"

const supabaseUrl = "https://itiuxewyxzjpyohuhjux.supabase.co"
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml0aXV4ZXd5eHpqcHlvaHVoanV4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY1NjUwMjMsImV4cCI6MjA5MjE0MTAyM30.ODLS1Emmr3olwRMJPLkTvCE5FPQksenE2etFHvf_pBk"

export const supabase = createClient(supabaseUrl, supabaseKey)
